import { handlePost } from './common';

class RsvpService {
  async postRsvp(data) {
    return await handlePost('/rsvp', { data });
  }
}

export default new RsvpService();
